import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { StickyNote } from "lucide-react";

export const HistoryAddNoteDialog = ({
  open,
  onOpenChange,
  memberId,
  setMemberId,
  noteText,
  setNoteText,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button className="bg-purple-700 hover:bg-purple-800 text-white" data-testid="add-note-btn">
          <StickyNote size={16} className="mr-2" /> Tambah Catatan
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-[#1a1a1b] border-red-900/30">
        <DialogHeader>
          <DialogTitle className="text-red-50">Tambah Catatan Member</DialogTitle>
          <DialogDescription className="text-gray-400">
            Tempelkan catatan ke member tertentu. Catatan akan muncul di history log dan dapat dicari.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="text-gray-300 mb-2 block">Member ID</Label>
            <Input
              value={memberId}
              onChange={(e) => setMemberId(e.target.value)}
              placeholder="Member ID (UUID)"
              className="bg-[#0f0f10] border-red-900/30 text-white"
              required
              data-testid="note-member-id"
            />
            <p className="text-xs text-gray-500 mt-1">
              Member ID bisa Anda dapatkan dari halaman Member Report (klik baris).
            </p>
          </div>
          <div>
            <Label className="text-gray-300 mb-2 block">Catatan</Label>
            <Textarea
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              placeholder="Tulis catatan..."
              className="bg-[#0f0f10] border-red-900/30 text-white"
              rows={5}
              required
              data-testid="note-text"
            />
          </div>
          <DialogFooter>
            <Button type="submit" className="bg-red-600 hover:bg-red-700 text-white" data-testid="save-note-btn">
              Simpan Catatan
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default HistoryAddNoteDialog;
